const fields = [{
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '团队名称',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'address',
    key: 'address',
    title: '地址',
    width: 100
  },
  {
    dataIndex: 'publishDate',
    key: 'publishDate',
    title: '发布日期',
    width: 120
  },
  {
    dataIndex: 'statusStr',
    key: 'status',
    width: 90,
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [{
    span: 12,
    label: '名称',
    component: 'AInput',
    placeholder: '请输入名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 7,
    label: '产业分类',
    component: 'ASelect',
    prop: 'industrialType',
    placeholder: '选择产业分类',
    allowClear: true,
    list: [{
        label: '新一代信息技术产业',
        value: '1'
      },
      {
        label: '生物医药产业',
        value: '3'
      },
      {
        label: '战略性产业集群',
        value: '4'
      },
      {
        label: '新能源汽车产业',
        value: '2'
      },
    ]
  }
]

const slotOpt = [{
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [{
        name: '编辑',
        cb: 'edit'
      },
      // { name: '发布', cb: 'issue', divider: true },
      {
        name: '删除',
        cb: 'singleDelete',
        divider: true
      }
    ]
  }
]

module.exports = {
  fields,
  slotOpt,
  formRow
}